var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.932,
    height: 34.517,
    viewBox: "0 0 25.932 34.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27777",
    "data-name": "Group 27777",
    transform: "translate(-1383.256 -640.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27372",
    "data-name": "Group 27372",
    transform: "translate(1380.119 640.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27371",
    "data-name": "Group 27371",
    transform: "translate(3.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31345",
    "data-name": "Path 31345",
    d: "M3.137,0H17.5c3.275,3.613,3.5,3.687,8.382,8.755V31.367A3.137,3.137,0,0,1,22.741,34.5H3.137A3.137,3.137,0,0,1,0,31.367V3.137A3.137,3.137,0,0,1,3.137,0Z",
    transform: "translate(0 0.013)",
    fill: "#6db1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31346",
    "data-name": "Path 31346",
    d: "M-4127.61-3334.075l6.359,7.247v-7.127Z",
    transform: "translate(4147.129 3342.656)",
    fill: "#4688b8",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31344",
    "data-name": "Path 31344",
    d: "M-4130.118-3345.017s-1.353,8.911,3.482,9.024a35.621,35.621,0,0,0,5-.34Z",
    transform: "translate(4147.565 3345.017)",
    fill: "#4688b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27776",
    "data-name": "Group 27776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32000",
    "data-name": "Path 32000",
    d: "M-8865.338-24079.869h14.41",
    transform: "translate(10254.328 24735)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32001",
    "data-name": "Path 32001",
    d: "M-8865.338-24079.869h14.41",
    transform: "translate(10254.328 24740)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32002",
    "data-name": "Path 32002",
    d: "M-8865.338-24079.869h9.532",
    transform: "translate(10254.328 24745)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.534e08fb569c6e95e710d359204c0e79.svg";
export { ForwardRef as ReactComponent };